import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('./base/base.module').then((m) => m.BaseModule),
  },
];
